import type { Device } from '@shared/types/context';
import type { Nullable, Optional } from '@shared/types/utils';

const parseAppPlatform = (osName: Optional<string>) => {
  if (osName && ['IPADOS', 'IOS'].includes(osName.toUpperCase())) {
    return 'GoiOS';
  }
  if (osName?.toUpperCase() === 'ANDROID') {
    return 'GoAndroid';
  }

  return null;
};

const userAgent = ({
  isMobilePhone,
  isTablet,
  isWebView = false,
  osName,
}: Device & { isWebView?: boolean } = {}) => {
  let deviceType = 'D';
  let platformType: Nullable<string> = 'Web';
  if (isTablet) {
    deviceType = 'T';
  } else if (isMobilePhone) {
    deviceType = 'M';
  }
  if (isWebView) {
    platformType = parseAppPlatform(osName);
  }

  return `${deviceType};${platformType}`;
};

export default userAgent;
